var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3442 11.2192C16.5859 10.6875 16.7309 10.1075 16.7309 9.47917C16.7309 7.14708 14.8338 5.25 12.5017 5.25C11.8734 5.25 11.2934 5.395 10.7617 5.63667L16.3442 11.2192Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5013 0.416504C5.8313 0.416504 0.417969 5.82984 0.417969 12.4998C0.417969 19.1698 5.8313 24.5832 12.5013 24.5832C19.1713 24.5832 24.5846 19.1698 24.5846 12.4998C24.5846 5.82984 19.1713 0.416504 12.5013 0.416504ZM12.5013 16.1248C9.69797 16.1248 7.12422 17.0915 5.08214 18.6865C3.68047 17.0069 2.83464 14.8561 2.83464 12.4998C2.83464 10.2644 3.59589 8.21025 4.87672 6.579L8.33255 10.0348C8.5863 11.9198 10.0605 13.4061 11.9455 13.6478L14.6038 16.3061C13.9151 16.1853 13.2142 16.1248 12.5013 16.1248ZM20.1259 18.4207L6.58047 4.87525C8.21172 3.59442 10.2659 2.83317 12.5013 2.83317C17.8421 2.83317 22.168 7.159 22.168 12.4998C22.168 14.7353 21.4067 16.7773 20.1259 18.4207Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUser);
export default __webpack_public_path__ + "static/media/NoUser.6438e77d2e4c0d5e248d8d615f25fbfd.svg";
export { ForwardRef as ReactComponent };